module.exports = __webpack_public_path__ + "img/shixianzhujigeshu.62135c60.png";